import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Accordion from 'react-bootstrap/Accordion';
import CommonIconMenu from '../assests/img/menu/common-icon-menu.svg';
import CriticalIconMenu from '../assests/img/menu/critical-icon-menu.svg';
import OverdueIConMenu from '../assests/img/menu/overdueTicket-icon-menu.svg';
import ReopenIConMenu from '../assests/img/menu/reopen-icon-menu.svg';
import ClosedIConMenu from '../assests/img/menu/closed-ticket-menu-icon.svg';
import E3IconMenu from '../assests/img/menu/e3-icon-menu.svg';
import E2IconMenu from '../assests/img/menu/e2-icon-menu.svg';
import E1IconMenu from '../assests/img/menu/e1-icon-menu.svg';
import InsightIconMenu from '../assests/img/menu/insight-icon-menu.svg';
import HierarchyIconMenu from '../assests/img/menu/Hierarchy-icon-menu.svg';
import SLAdIconMenu from '../assests/img/menu/SLA-Duration-icon-menu.svg';
import NonViolatedIconMenu from '../assests/img/menu/NonVoilated-icon.png';
import { MultiSelect } from 'react-multi-select-component';
import UnderReviewMenu from '../assests/img/underReview.svg';
import UpArrowDropdown from '../assests/img/UpArrow_dropdown.svg'
import DownArrowDropdown from '../assests/img/DownArrow_dropdown.svg'
import ReturnedTicketIcon from '../assests/img/menu/Returned Ticket.svg'
import { getLocation } from "../utils/API/TicketAPI";

const Sidebar = ({ activeTab, handleTabClick, locationData, selectedLocation, handleChange,ticketCount, loading , filterTab, setFilterTab,onTabChange, myTicketKpiCount, isTicketManager, isTicketUser, fetchUserRoles}) => {
  console.log('Sidebar Props:', { myTicketKpiCount, isTicketUser, isTicketManager });

  const [isLoading, setIsLoading] = useState(false);
  const [locationSla, setLocationSla] = useState([]);
  
  const location = useLocation();
  const currentPath = location.pathname;
  console.log(locationData,"dddd")
  

  const handleTabClickWithFetch = (tab) => {

    onTabChange('overview');
    
    if (tab === activeTab || isLoading) return;
    setIsLoading(true);
    setFilterTab("")
    handleTabClick(tab);
    
    // Set activeTab in localStorage for My Tickets section
    if (tab === "opened" || tab === "close") {
    localStorage.setItem("activeTab", tab);
    }
    fetchUserRoles();
    // Simulate data fetching
    setTimeout(() => {
    setIsLoading(false);
    }, 900); // Adjust the timeout as needed based on actual data fetching
    };

  const ArrowRenderer = ({ expanded }) => <>{
    expanded ?

      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="5" viewBox="0 0 12 6">
        <path id="UpArrow_dropdown" d="M6,0,0,6H12Z" fill="#ccc" />
      </svg>
      :
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="5" viewBox="0 0 12 6">
        <path id="UpArrow_dropdown" d="M6,6,0,0H12Z" fill="#ccc" />
      </svg>
  }</>;



  const ValueRenderer = (selected, options) => {
    if (selected.length === options.length) {
      return 'All locations';
    } else if (selected.length === 1) {
      return selected[0].label;
    } else {
      return selected.length > 0
        ? `${selected.length} locations selected`
        : 'Select';
    }
  };


  const defaultActiveKey = currentPath === '/ticket-lists' ? '0' :
    ['/insights', '/hierarchy', '/sla-durations'].includes(currentPath) ? '1' : null;


   const fetchAllLocation = async (page) => {
      try {
        const response = await getLocation(page);
        if (response.statusValue === 200) {
          setLocationSla(response.data);
        } else {
          setLocationSla([]);
        }
      } catch (error) {
        // showToast(
        //   `Error fetching location : ${error?.response?.data?.error?.message}`
        // );
      }
    };
    useEffect(() => {
      fetchAllLocation(1);
    }, []);


  return (
    <div className="sideMenu shadow bg-dark">
      <div className="sidebar">


      <Accordion defaultActiveKey={defaultActiveKey} 
         alwaysOpen
      >

   
      {(isTicketManager || isTicketManager === undefined )&& (
           <><Accordion.Item eventKey="0">
              <Accordion.Header>MANAGE TICKETS</Accordion.Header>

              <Accordion.Body>

                {window.location.pathname == '/ticket-lists' ?
                  <div className="SidebarLocation" style={{ marginTop: '0' }}>
                    <MultiSelect
                      //options={locationData.map(location => ({ value: location._id, label: location.locationName }))}
                      options={locationData
                        .sort((a, b) => a.locationName.localeCompare(b.locationName)) // sort by locationName
                        .map(location => ({ value: location._id, label: location.locationName }))}
                      value={selectedLocation}
                      onChange={handleChange}
                      labelledBy="Select"
                      selectAllLabel="Select All"
                      ArrowRenderer={ArrowRenderer}
                      className="multi-select multi-select-sm"
                      valueRenderer={ValueRenderer} />
                  </div> : ""}

                {/* <hr className="nav-hr" /> */}
                {/* <div className={`col-md-12 ${loading ? "unclickable" : ""}`}> */}
                <div className="col-md-12">

                  <ul className="navbar-nav">

                    <li className={`nav-item ${window.location.pathname === "/ticket-lists" && activeTab === "open" || filterTab === "open" ? "li-active" : ""}`}>
                      <Link
                        to="/ticket-lists"
                        className="nav-link"
                        onClick={() => handleTabClickWithFetch("open")}

                      >
                        <img src={CommonIconMenu} alt="" />
                        <div className="SideMenu-txt">
                          <span>Open Tickets</span>
                          {window.location.pathname === "/ticket-lists" ? <span className="t-count-menu">{selectedLocation.length > 0 ? ticketCount?.openTickets : 0}</span> : ""}
                        </div>
                      </Link>
                    </li>

                    <hr className="nav-hr" />

                    <li className={`nav-item ${activeTab === "critical" || filterTab === "critical" ? "li-active" : ""}`}>
                      <Link
                        to="/ticket-lists"
                        className="nav-link"
                        onClick={() => handleTabClickWithFetch("critical")}
                      >
                        <img src={CriticalIconMenu} alt="" />
                        <div className="SideMenu-txt">
                          <span>Critical Tickets</span>
                          {window.location.pathname === "/ticket-lists" ? <span className="t-count-menu">{selectedLocation.length > 0 ? ticketCount?.criticalTickets : 0}</span> : ""}
                        </div>
                      </Link>
                    </li>

                    <li className={`nav-item ${activeTab === "returned" || filterTab === "returned" ? "li-active" : ""}`}>
                      <Link
                        to="/ticket-lists"
                        className="nav-link"
                        onClick={() => handleTabClickWithFetch("returned")}
                      >
                        <img src={ReturnedTicketIcon} alt="" />
                        <div className="SideMenu-txt">
                          <span>Returned Tickets</span>
                          {window.location.pathname === "/ticket-lists" ? <span className="t-count-menu">{selectedLocation.length > 0 ? ticketCount?.returnedTickets : 0}</span> : ""}
                        </div>
                      </Link>
                    </li>

                    <li className={`nav-item ${activeTab === "reopen" || filterTab === "reopen" ? "li-active" : ""}`}>
                      <Link
                        to="/ticket-lists"
                        className="nav-link"
                        onClick={() => handleTabClickWithFetch("reopen")}
                      >
                        <img src={ReopenIConMenu} alt="" />
                        <div className="SideMenu-txt">
                          <span>Re-opened Tickets</span>
                          {window.location.pathname === "/ticket-lists" ? <span className="t-count-menu">{selectedLocation.length > 0 ? ticketCount?.reopenedTickets : 0}</span> : ""}
                        </div>

                      </Link>
                    </li>

                    <li className={`nav-item ${activeTab === "e3" || filterTab === "e3" ? "li-active" : ""}`}>
                      <Link
                        to="/ticket-lists"
                        className="nav-link"
                        onClick={() => handleTabClickWithFetch("e3")}
                      >
                        <img src={E3IconMenu} alt="" />
                        <div className="SideMenu-txt">
                          <span>E3</span>
                          {window.location.pathname === "/ticket-lists" ? <span className="t-count-menu">{selectedLocation.length > 0 ? ticketCount?.e3Tickets : 0}</span> : ""}
                        </div>
                      </Link>
                    </li>
                    <li className={`nav-item ${activeTab === "e2" || filterTab === "e2" ? "li-active" : ""}`}>
                      <Link
                        to="/ticket-lists"
                        className="nav-link"
                        onClick={() => handleTabClickWithFetch("e2")}
                      >
                        <img src={E2IconMenu} alt="" />
                        <div className="SideMenu-txt">
                          <span>E2</span>
                          {window.location.pathname === "/ticket-lists" ? <span className="t-count-menu">{selectedLocation.length > 0 ? ticketCount?.e2Tickets : 0}</span> : ""}
                        </div>
                      </Link>
                    </li>
                    <li className={`nav-item ${activeTab === "e1" || filterTab === "e1" ? "li-active" : ""}`}>
                      <Link
                        to="/ticket-lists"
                        className="nav-link"
                        onClick={() => handleTabClickWithFetch("e1")}
                      >
                        <img src={E1IconMenu} alt="" />
                        <div className="SideMenu-txt">
                          <span>E1</span>
                          {window.location.pathname === "/ticket-lists" ? <span className="t-count-menu">{selectedLocation.length > 0 ? ticketCount?.e1Tickets : 0}</span> : ""}
                        </div>
                      </Link>
                    </li>

                    <li className={`nav-item ${activeTab === "overdue" || filterTab === "overdue" ? "li-active" : ""}`}>
                      <Link
                        to="/ticket-lists"
                        className="nav-link"
                        onClick={() => handleTabClickWithFetch("overdue")}
                      >
                        <img src={OverdueIConMenu} alt="" />
                        <div className="SideMenu-txt">
                          <span>Overdue Tickets</span>
                          {window.location.pathname === "/ticket-lists" ? <span className="t-count-menu">{selectedLocation.length > 0 ? ticketCount?.overDueTickets : 0}</span> : ""}
                        </div>
                      </Link>
                    </li>

                    <li className={`nav-item ${activeTab === "nonviolated" || filterTab === "nonviolated" ? "li-active" : ""}`}>
                      <Link
                        to="/ticket-lists"
                        className="nav-link"
                        onClick={() => handleTabClickWithFetch("nonviolated")}
                      >
                        <img src={NonViolatedIconMenu} width={'12px'} alt="" />
                        <div className="SideMenu-txt">
                          <span>Non-violated Tickets</span>
                          {window.location.pathname === "/ticket-lists" ? <span className="t-count-menu">{selectedLocation.length > 0 ? ticketCount?.nonViolatedTickets : 0}</span> : ""}
                        </div>
                      </Link>
                    </li>

                    <hr className="nav-hr" />

                    <li className={`nav-item ${activeTab === "underreview" || filterTab === "underreview" ? "li-active" : ""}`}>
                      <Link
                        to="/ticket-lists"
                        className="nav-link"
                        onClick={() => handleTabClickWithFetch("underreview")}
                      >
                        <img src={UnderReviewMenu} alt="" />
                        <div className="SideMenu-txt">
                          <span>Under Review</span>
                          {window.location.pathname === "/ticket-lists" ? <span className="t-count-menu">{selectedLocation.length > 0 ? ticketCount?.underReview : 0}</span> : ""}
                        </div>
                      </Link>
                    </li>
                    <hr className="nav-hr" />

                    <li className={`nav-item ${activeTab === "closed" || filterTab === "closed" ? "li-active" : ""}`}>
                      <Link
                        to="/ticket-lists"
                        className="nav-link"
                        onClick={() => handleTabClickWithFetch("closed")}
                      >
                        <img src={ClosedIConMenu} alt="" />
                        <div className="SideMenu-txt">
                          <span>Closed Tickets</span>
                          {window.location.pathname === "/ticket-lists" ? <span className="t-count-menu">{selectedLocation.length > 0 ? ticketCount?.closedTickets : 0}</span> : ""}
                        </div>
                      </Link>
                    </li>



                  </ul>

                </div>

              </Accordion.Body>

            </Accordion.Item><Accordion.Item eventKey="1">
                <Accordion.Header>OVERVIEW</Accordion.Header>

                <Accordion.Body>
                  <ul className="navbar-nav">

                    <li className={`nav-item ${window.location.pathname === "/insights" && activeTab === "open" ? "li-active" : ""}`}>
                      <Link to="/insights" className="nav-link">
                        <img src={InsightIconMenu} alt="" />
                        <div className="SideMenu-txt">
                          <span>Insights</span>
                        </div>

                      </Link>
                    </li>

                    <li className={`nav-item ${window.location.pathname === "/hierarchy" ? "li-active" : ""}`}>
                      <Link to="/hierarchy" className="nav-link">
                        <img src={HierarchyIconMenu} alt="" />
                        <div className="SideMenu-txt">
                          <span>Hierarchy Levels</span>
                        </div>
                      </Link>
                    </li>


                    {locationSla.length > 1 || (locationSla.length === 1 && locationSla[0].locationShortCode !== 'GITAM') ? (
                      <li className={`nav-item ${window.location.pathname === "/sla-durations" ? "li-active" : ""}`}>
                        <Link to="/sla-durations" className="nav-link">
                          <img src={SLAdIconMenu} alt="" />
                          <div className="SideMenu-txt">
                            <span>SLA Durations</span>
                          </div>
                        </Link>
                      </li>
                    ) : null}

                  </ul>
                </Accordion.Body>

              
               </Accordion.Item><Accordion.Item eventKey="2">
                <Accordion.Header>MY TICKETS</Accordion.Header>

                <Accordion.Body>
                  <ul className="navbar-nav">
                    {console.log(myTicketKpiCount, "myTicketKpiCount")}
                    <li className={`nav-item ${activeTab === "opened" || filterTab === "opened" ? "li-active" : ""}`}>
                      <Link
                        to="/ticket-lists"
                        className="nav-link"
                        onClick={() => handleTabClickWithFetch("opened")}
                      >
                        <img src={CommonIconMenu} alt="" />
                        <div className="SideMenu-txt">
                          <span>Open Tickets</span>
                          {window.location.pathname === "/ticket-lists" ? <span className="t-count-menu">{myTicketKpiCount?.openTickets}</span> : ""}
                        </div>
                      </Link>
                    </li>

                    <li className={`nav-item ${activeTab === "close" || filterTab === "close" ? "li-active" : ""}`}>
                      <Link
                        to="/ticket-lists"
                        className="nav-link"
                        onClick={() => handleTabClickWithFetch("close")}
                      >
                        <img src={ClosedIConMenu} alt="" />
                        <div className="SideMenu-txt">
                          <span>Closed Tickets</span>
                          {window.location.pathname === "/ticket-lists" ? <span className="t-count-menu">{myTicketKpiCount?.closedTickets}</span> : ""}
                        </div>
                      </Link>
                    </li>

                  </ul>
                </Accordion.Body>

              </Accordion.Item></> )}

              {isTicketUser && !isTicketManager && (
                <Accordion.Item eventKey="0">
                <Accordion.Header>MY TICKETS</Accordion.Header>

                <Accordion.Body>
                  <ul className="navbar-nav">
                    {console.log(myTicketKpiCount, "myTicketKpiCount")}
                    <li className={`nav-item ${activeTab === "opened" || filterTab === "opened" ? "li-active" : ""}`}>
                      <Link
                        to="/ticket-lists"
                        className="nav-link"
                        onClick={() => handleTabClickWithFetch("opened")}
                      >
                        <img src={CommonIconMenu} alt="" />
                        <div className="SideMenu-txt">
                          <span>Open Tickets</span>
                          {window.location.pathname === "/ticket-lists" ? <span className="t-count-menu">{myTicketKpiCount?.openTickets}</span> : ""}
                        </div>
                      </Link>
                    </li>

                    <li className={`nav-item ${activeTab === "close" || filterTab === "close" ? "li-active" : ""}`}>
                      <Link
                        to="/ticket-lists"
                        className="nav-link"
                        onClick={() => handleTabClickWithFetch("close")}
                      >
                        <img src={ClosedIConMenu} alt="" />
                        <div className="SideMenu-txt">
                          <span>Closed Tickets</span>
                          {window.location.pathname === "/ticket-lists" ? <span className="t-count-menu">{myTicketKpiCount?.closedTickets}</span> : ""}
                        </div>
                      </Link>
                    </li>

                  </ul>
                </Accordion.Body>

              </Accordion.Item> )}

        </Accordion>
      </div>
    </div>
  );
};

export default Sidebar;